<div class="content">
  <h1>Not Found</h1>
  <p>Something went wrong</p>
</div>
